import { authPost } from "../http_client.js";
import { PrimedResponses } from "../primed_responses.js";
import type { PlayerDto } from "../dto/player.dto.js";
import type { ConfigHashesResponse } from "./player.requests.js";

export interface BootstrapResponse
{
  player: PlayerDto;
  config_hashes: Record<string, string>;
  configs: Record<string, unknown>;
  generated_at: string;
}

export function fetchBootstrap( known_hashes: Record<string, string>, types: string[] ): Promise<BootstrapResponse>
{
  return authPost<BootstrapResponse>( 'api/player/me/bootstrap', { config_hashes: known_hashes, types } );
}

export function primeFromBootstrap( payload: BootstrapResponse ): number
{
  let primed = 0;
  const hashes = payload.config_hashes ?? {};

  const hashes_response: ConfigHashesResponse = { hashes, generated_at: payload.generated_at };
  PrimedResponses.set( 'config_hashes', hashes_response );
  primed++;

  for ( const [ type, data ] of Object.entries( payload.configs ?? {} ) )
  {
    PrimedResponses.set( `content_config:${type}`, { data, hash: hashes[type] ?? null } );
    primed++;
  }

  return primed;
}
